<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div class="container">
    <form id="takeorder">
      <!--标题-->
      <mt-header fixed :title="title" class="head" id="header">
        <div slot="left" @click="toBackClick">
          <mt-button icon="back"></mt-button>
        </div>
      </mt-header>
      <!--已下订单数-->
      <div class="tips" v-show="count>0" @click="toDetail" id="tips">
        <div class="content c_flex c_flex_between c_item_center">
          <div class>该工程已下 {{count}} 单</div>
          <div @click="toDetail">点击查看</div>
        </div>
        <div style="height:6vh;"></div>
      </div>
      <!--单元格-->
      <div class="c_p_t_10">
        <div class="item-group c_m_b_10 bg_white" @click="partoneShow = true">
          <div class="item-title c_nowrap">维修部位</div>
          <div class="item-content">
            <span class="item-value c_no_pointer">
              <input type="text" placeholder="请选择维修部位" v-model="type" />
            </span>
          </div>
        </div>
        <div class="item-group c_m_b_10 bg_white">
          <div class="item-title c_nowrap">经办方</div>
          <div class="item-content">
            <span class="item-value">
              <input type="text" placeholder="请填写经办方" v-model="operator" />
            </span>
          </div>
        </div>
        <div class="item-group c_m_b_10 bg_white">
          <div class="item-title c_nowrap">委托人</div>
          <div class="item-content">
            <span class="item-value">
              <input type="text" placeholder="请填写委托人" v-model="clientname" />
            </span>
          </div>
        </div>
        <div class="item-group c_m_b_10 bg_white">
          <div class="item-title c_nowrap">联系电话</div>
          <div class="item-content">
            <span class="item-value">
              <input type="number" placeholder="请填写联系电话" v-model="telphone" />
            </span>
          </div>
        </div>
        <div class="item-group c_m_b_10 bg_white">
          <div class="item-title c_nowrap">渗漏原因</div>
          <div class="item-content">
            <span class="item-value">
              <input type="text" placeholder="请填写渗漏原因" v-model="reason" />
            </span>
          </div>
        </div>
        <div class="item-group c_m_b_10 bg_white">
          <div class="item-title c_nowrap">维修面积</div>
          <div class="item-content c_flex c_flex_center">
            <span class="item-value">
              <input type="text" placeholder="请填写维修面积" @input="areaChange" v-model="area" />
            </span>
            <van-dropdown-menu style="height:21px;" class="units">
              <van-dropdown-item v-model="units" :options="unitOptions" style="font-size:3.5vw;" />
            </van-dropdown-menu>
          </div>
        </div>

        <!--选择服务内容按钮-->
        <van-sticky
          :offset-top="offsetTop"
          style="width: 100%;margin-bottom:2vw;"
          :z-index="1"
          id="sticky"
        >
          <van-button type="info" @click.prevent.stop="serviceClick" style="width:100%;">
            <span>
              <van-icon
                name="add-o"
                color="rgb(3,162,228)"
                size="1.3em"
                style="vertical-align: middle;font-weight: bold;"
              />选择服务内容
            </span>
          </van-button>
          <div style="clear:both;"></div>
        </van-sticky>

        <!--展示服务内容-->
        <div v-for="(type,i) of types" :key="i" v-show="getInfo(type) > 0" class="card">
          <div class="card_title">{{renderOptions('type',type) || type}}</div>
          <div
            v-for="(serviceItem,j) of serviceItems"
            v-show="serviceItem.isselected && serviceItem.type == type"
            :key="j"
            class="card_item"
          >
            <div class="card_item_del">
              <van-icon
                name="delete"
                @click="serviceItem.isselected = false;serviceItem.num = 1"
                style="padding:1vw;border-radius:50%;"
              />
            </div>
            <div style="flex: 1;">
              <div style="margin-bottom:2vw;">{{serviceItem.itemname}}</div>
              <div class="card_item_info">
                <div>
                  <span style="color:red;">¥ {{serviceItem.price}}</span>
                  <span>/{{renderOptions("unit",serviceItem.unit) || serviceItem.unit}}</span>
                  <span style="line-height: 3.5vw;vertical-align: middle;">
                    <van-icon
                      name="more-o"
                      size="3.5vw"
                      color="rgb(184,195,206)"
                      @click="$toast(serviceItem.memo)"
                    />
                  </span>
                </div>
                <div class="c_rt sub-opera" style="display: flex;">
                  <button
                    class="van-stepper__minus"
                    @click.prevent.stop="serviceItem.num = (serviceItem.num - 1 <= 0 ? serviceItem.num : serviceItem.num - 1)"
                    :class="serviceItem.num - 1 <= 0?'van-stepper__minus--disabled':''"
                  ></button>
                  <input
                    class="c_center"
                    type="area"
                    @input="oninput_area(serviceItem)"
                    @blur="oninput_blur(serviceItem)"
                    v-model="serviceItem.num"
                    style="background-color: #f2f3f5;margin: 0 4px;"
                  />
                  <button class="van-stepper__plus" @click.prevent.stop="serviceItem.num++"></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--展示自定义增项-->
        <div class="card" v-show="getInfo('custom') > 0">
          <div class="card_title">自定义</div>
          <div
            v-for="(subitem,j) in serviceItems"
            v-show="subitem.type == 'custom' && subitem.isselected"
            :key="j"
            class="card_item"
          >
            <div class="card_item_del">
              <van-checkbox v-model="subitem.isselected">
                <img slot="icon" slot-scope="props" :src="props.checked ? '':''" />
                <van-icon name="delete" style="padding:1vw;border-radius:50%;" />
              </van-checkbox>
            </div>
            <div style="flex: 1;">
              <div style="margin-bottom:2vw;">
                <input type="text" v-model="subitem.itemname" />
              </div>
              <div class="card_item_info">
                <div>
                  <span style="color:red;">¥ {{subitem.price}}</span>
                  <!--<span style="line-height: 3.5vw;vertical-align: middle;"><van-icon name="more-o" size="3.5vw" @click="$toast(subitem.memo)"/></span>-->
                </div>
                <!--<div>
                  <van-stepper v-model="subitem.num" />
                </div>-->
                <div
                  class="c_rt sub-opera"
                  :class="subitem.editable==2?'c_gray c_no_pointer':''"
                  style="display: flex;"
                >
                  <button
                    class="van-stepper__minus"
                    @click.prevent.stop="subitem.num = (subitem.num - 1 < 1 ? 1 : subitem.num - 1)"
                    :class="subitem.num - 1 < 1?'van-stepper__minus--disabled':''"
                  ></button>
                  <input
                    class="c_center"
                    :class="subitem.editable==2?'c_gray':''"
                    placeholder="0"
                    type="area"
                    min="1"
                    name
                    @input="oninput_area(subitem)"
                    v-model="subitem.num"
                    style="background-color: #f2f3f5;margin: 0 4px;"
                  />
                  <button class="van-stepper__plus" @click.prevent.stop="subitem.num++"></button>
                </div>
              </div>
              <div>
                <span>
                  <input
                    type="text"
                    v-model="subitem.memo"
                    style="width: 100%;color:rgb(184,195,206)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <!--展示折扣-->
        <div class="card" v-show="serviceItems.length > 1">
          <div class="card_title">折扣</div>
          <div
            class="card_item"
            v-for="(item,j) in serviceItems"
            v-show="item.itemtype == '2' && item.isselected"
            :key="j"
          >
            <div class="card_item_del">
              <!--<van-icon name="delete" style="padding:1vw;border-radius:50%;"/>-->
            </div>
            <div style="flex: 1;">
              <div style="margin-bottom:2vw;">{{item.memo}}</div>
              <div class="card_item_info">
                <div>
                  <span style="color:red;">{{item.num}}%</span>
                </div>
                <div
                  class="c_rt sub-opera"
                  :class="false?'c_gray c_no_pointer':''"
                  style="display: flex;"
                >
                  <button
                    class="van-stepper__minus"
                    @click.prevent.stop="item.num = (item.num - 1 < 90 ? 90 : item.num - 1)"
                    :class="item.num - 1 < 90?'van-stepper__minus--disabled':''"
                  ></button>
                  <input
                    class="c_center"
                    :class="false?'c_gray':''"
                    @blur="discountCheck(item)"
                    placeholder="0"
                    v-model="item.num"
                    style="background-color: #f2f3f5;margin: 0 4px;"
                  />
                  <button
                    class="van-stepper__plus"
                    @click.prevent.stop="item.num = (item.num + 1 > 100 ? 100 : item.num + 1)"
                    :class="item.num + 1 > 100?'van-stepper__minus--disabled':''"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--自定义增减项 按钮-->
        <van-sticky v-show="serviceItems.length > 1" style="width: 100%;" id="sticky">
          <van-button type="info" @click.prevent.stop="addItemClick" style="float:left;">
            <span>
              <van-icon
                name="add-o"
                color="rgb(3,162,228)"
                size="1.3em"
                style="vertical-align: middle;font-weight: bold;"
              />新增自选增加项
            </span>
          </van-button>
          <van-button type="info" @click.prevent.stop="delItemClick" style="float:right;">
            <span>
              <van-icon
                name="add-o"
                color="rgb(3,162,228)"
                size="1.3em"
                style="vertical-align: middle;font-weight: bold;"
              />新增自选减除项
            </span>
          </van-button>
          <div style="clear:both;"></div>
        </van-sticky>
      </div>
      <!--单元格结束-->

      <div style="height:11.53vh;width:100%;"></div>

      <!--底部金额、按钮-->
      <div class="item-foot">
        <div class="c_flex">
          <div class="item-total c_flex_1 c_left c_nowrap">
            <span>合计金额：</span>
            <span class="c_orange">¥ {{totalamount||0.00}}</span>
          </div>
          <div @click="takeReport" class="item-save bg_gray c_center">生成报价</div>
          <div @click="saveOrderClick" class="item-save bg_blue c_center">确认下单</div>
        </div>
      </div>
    </form>

    <!--选择服务内容-->
    <van-popup
      v-model="fineItemShow"
      position="bottom"
      :style="{ height: '40%' }"
      safe-area-inset-bottom
      class="popup"
    >
      <div class="popup-top">
        <van-button
          v-for="(agelimit,i) of agelimits"
          :key="i"
          :plain="activeAgelimit == agelimit ? false : true"
          @click="agelimitClick(agelimit)"
          type="primary"
          style="padding:0;font-size:12px;"
        >{{agelimit}}年</van-button>
      </div>
      <div class="popup-content">
        <div class="popup-left">
          <div
            v-for="(type,i) of types"
            :key="i"
            @click="activeType = type"
            :class="activeType == type ? 'left-active':''"
          >
            {{renderOptions('type',type) || type}}
            <div
              class="van-info van-sidebar-item__info"
              v-if="getInfo(type) > 0"
              style="top: 15px;right: 20px;"
            >{{getInfo(type)}}</div>
          </div>
        </div>
        <div class="popup-right">
          <div
            v-for="(item,i) of serviceItems"
            :key="i"
            v-show="item.type == activeType && (activeAgelimit == item.agelimit || item.agelimit == '')"
            @click="itemClick(item)"
          >
            <span>{{item.itemname}}</span>
            <van-icon v-show="item.isselected" name="checked" color="#ee0a24" />
          </div>
        </div>
      </div>
    </van-popup>

    <!--维修部位-->
    <van-picker
      :columns="columns1"
      value-key="codetext"
      ref="vanPicker1"
      @confirm="onPartoneConfirm"
      @cancel="onPartoneCancel"
      v-show="partoneShow"
      show-toolbar
      title="请选择维修部位一级"
      confirm-button-text="下一步"
    />
    <van-picker
      :columns="columns2"
      value-key="codetext"
      ref="vanPicker2"
      @confirm="onParttwoConfirm"
      @cancel="partoneShow = true;parttwoShow = false;"
      v-show="parttwoShow"
      show-toolbar
      title="请选择维修部位二级"
      cancel-button-text="返回"
    />
    <van-overlay
      :show="partoneShow || parttwoShow"
      @click="partoneShow = false;parttwoShow = false;"
    />
  </div>
</template>

<script>
import { Indicator, Toast } from "mint-ui";
export default {
  data: function() {
    return {
      //标题"下单"
      title: "",
      //工程id
      serviceid: "",
      //该工程的订单数量
      count: 0,
      type: null,
      // 委托方
      clientname: "",
      // 经办人
      operator: "",
      //电话
      telphone: "",
      //渗漏原因
      reason: "",
      //维修面积
      area: null,
      //维修面积的单位
      units: "平方米",
      unitOptions: [
        { text: "平方米", value: "平方米" },
        { text: "延米", value: "延米" },
        { text: "点", value: "点" },
        { text: "处", value: "处" }
      ],

      //维修部位
      part: "",
      columns1: [],
      columns2: [],
      partone: {
        name: "",
        value: ""
      },
      parttwo: {
        name: "",
        value: ""
      },
      partoneShow: false,
      parttwoShow: false,

      //服务内容
      fineItemShow: false, // 是否展示服务内容选择器
      serviceItems: [
        // {type:1,isselected:true,itemname:'item-1',itemid:1,price:210,num:1,memo:'备注1'},
        // {type:2,isselected:false,itemname:'item-2',itemid:2,price:220,num:2,memo:'备注2'},
      ],

      //所有的服务环节
      types: [],
      activeType: 1, //当前服务环节
      //所有的年限
      agelimits: [],
      activeAgelimit: "", //当前年限
      //已选中分类对应个数
      infos: {},

      //字典
      options: {
        type: "" //服务环节
      },

      // 总价
      totalamount: 0,

      offsetTop: 0 // 添加按钮吸顶距离
    };
  },
  mounted: function() {
    //获取下单流程信息
    if (localStorage["obj"]) {
      var obj = JSON.parse(localStorage["obj"]);
      this.title = obj.procedure.itemname; //工序名称"下单"
      if (obj.billid) {
        this.serviceid = obj.billid; //工程id
      } else {
        this.$router.push("/imgupdate");
      }
      //获取该工程订单数
      this.loadOrders();
    } else {
      this.$router.push("/imgupdate");
    }

    this.getCodeTree("REPAIR_PART_TYPE", null, "columns1"); //获取一级维修部位
    this.getCode("SERVICE_STEPS_TYPE", "type"); //获取服务环节
    this.getCode("MEASUREMENT_UNIT_TYPE", "unit"); //获取单位
  },
  methods: {
    toBackClick: function() {
      this.$router.push("/imgupdate");
    },
    // 查看该工程的订单数
    loadOrders: function() {
      var $that = this;
      var serviceid = this.serviceid;
      this.$ajax.get(
        this.$$api.mobile.getOrderNum,
        {
          serviceid: $that.serviceid
        },
        response => {
          if (response.status >= 200 && response.status < 300) {
            var count = response.data.count || 0;
            $that.count = count;
            $that.clientname = response.data.clientname || "";
            $that.telphone = response.data.telphone || "";
            // 查看顶部高度
            setTimeout(() => {
              var height = document.getElementById("header").clientHeight;
              if (count > 0) {
                height += document.getElementById("tips").clientHeight;
              }
              $that.offsetTop = height;
            }, 1000);
          } else {
            // console.log(response,this.sid);
          }
        }
      );
    },
    // 跳转到工程的订单列表
    toDetail: function() {
      if (this.serviceid) {
        localStorage["serviceid"] = this.serviceid;
        this.$router.push("/order");
      }
    },

    //查字典表
    getCode(codeType, dataName) {
      var that = this;
      this.$ajax.get(
        this.$$api.mobile.getCode,
        {
          codeType
        },
        function(res) {
          if (res.status == 200) {
            var arr = res.data;
            var list = [];
            for (var obj of arr) {
              list.push(obj);
            }
            that.options[dataName] = list;
          }
        }
      );
    },

    //获取树表
    getCodeTree(codetype, parentId, dataName) {
      var that = this;
      this.$ajax.get(
        this.$$api.mobile.getCodeTree,
        {
          codetype,
          parentId
        },
        function(res) {
          if (res.status == 200) {
            var arr = res.data.detailMsg.data;
            var list = [];
            for (var obj of arr) {
              list.push(obj);
            }
            that[dataName] = list;
          }
        }
      );
    },
    //渲染codevalue
    renderOptions(optionName, val) {
      for (var item of this.options[optionName]) {
        if (item.codevalue == val) {
          return item.codetext;
        }
      }
    },

    //维修部位相关
    // 取消一级维修部位
    onPartoneCancel() {
      this.partoneShow = false;
    },
    //下一步
    onPartoneConfirm() {
      var partone = this.$refs.vanPicker1.getValues()[0];
      this.getCodeTree("REPAIR_PART_TYPE", partone.codevalue, "columns2");
      this.partoneShow = false;
      this.parttwoShow = true;
    },
    // 确认二级部位
    onParttwoConfirm() {
      var partone = this.$refs.vanPicker1.getValues()[0];
      this.partone.name = partone.codetext;
      this.partone.value = partone.codevalue;
      var parttwo = this.$refs.vanPicker2.getValues()[0];
      this.parttwo.name = parttwo.codetext;
      this.parttwo.value = parttwo.codevalue;
      this.type = partone.codetext + " - " + parttwo.codetext;
      this.parttwoShow = false;
      this.getServiceItems();
    },

    //点击添加服务内容
    serviceClick: function() {
      if (!this.type) {
        this.$messagebox("请选择维修部位");
        return;
      }
      this.fineItemShow = true;
    },

    //获取服务内容
    getServiceItems: function(activeAgelimit) {
      let $that = this;
      Indicator.open();
      $that.$ajax.get(
        $that.$$api.mobile.getServiceItems,
        {
          search_partone: $that.partone.value,
          search_parttwo: $that.parttwo.value
        },
        response => {
          if (response.status >= 200 && response.status < 300) {
            var data = response.data.detailMsg.data;

            if (data && data.length > 0) {
              //所有服务内容

              var typeObj = {};
              var agelimitObj = {};
              for (var obj of data) {
                obj.isselected = false;
                obj.num = $that.area || 1;

                //获取总共有多少种服务环节
                typeObj[obj.type] = "";
                //获取总共有多少个年限
                if (obj.agelimit) {
                  agelimitObj[obj.agelimit] = "";
                }
              }

              $that.serviceItems = data;
              Indicator.close();

              //获取总共有多少个type
              var types = [];
              for (var key in typeObj) {
                types.push(key);
              }
              $that.types = types;

              //获取总共有多少个年限
              var agelimits = [];
              for (var key in agelimitObj) {
                agelimits.push(key);
              }
              $that.agelimits = agelimits;
              if (!activeAgelimit) {
                //没传年限,默认选择最小年限
                $that.activeAgelimit = agelimits[0];
              }

              //添加折扣
              let obj = {};
              obj.itemid = "";
              obj.itemname = "折扣";
              obj.price = 0;
              obj.num = 100;
              obj.servicecost = 100;
              obj.materialcost = 0;
              obj.memo = "请输入90到100之间的折扣";
              obj.itemtype = 2;
              obj.isselected = true;
              $that.serviceItems.push(obj);
            } else {
              $that.$messagebox("该维修部位没有维护服务内容");
              Indicator.close();
            }
          } else {
            console.log(response, 0);
          }
        }
      );
    },
    //获取对应服务环节的已勾选数
    getInfo(type) {
      var num = 0;
      for (var item of this.serviceItems) {
        if (item.type == type && item.isselected) {
          num++;
        }
      }
      return num;
    },
    // 筛选年限
    agelimitClick(agelimit) {
      // 年限没变 不做修改
      if (this.activeAgelimit == agelimit) {
        this.activeAgelimit = agelimit;
      } else {
        var hasselected = false;
        for (var item of this.serviceItems) {
          if (item.type != 2) {
            if (item.isselected) hasselected = true; //有已选中项才提示
          }
        }
        if (hasselected) {
          this.$dialog
            .confirm({
              title: "提醒",
              message: "修改年限将清空已勾选细项！",
              confirmButtonText: "确认修改",
              cancelButtonText: "取消修改"
            })
            .then(() => {
              // 修改选中年限
              this.activeAgelimit = agelimit;
              // 获取对应年限的产品细项
              this.getServiceItems(agelimit);
            })
            .catch(() => {});
        } else {
          this.activeAgelimit = agelimit;
        }
      }
    },
    //点击服务内容
    itemClick(obj) {
      console.log(obj);
      if (obj.servicesteps == 1) {
        this.serviceItems.map(function(item) {
          if (item.servicesteps == 1) {
            item.isselected = false;
          }
        });
      }
      obj.isselected = !obj.isselected;
    },

    // 修改单项维修面积
    oninput_area(obj) {
      var val = obj.num;
      // 通过正则过滤小数点后两位
      if (!val) return;
      val = val.match(/^\d*(\.?\d*)/g)[0] || 1;
      val = val < 1 ? 1 : val;
      obj.num = val || 1;
    },
    oninput_blur(obj) {
      if (!obj.num || obj.num == "0") {
        Toast("请输入大于0的数字！");
        obj.num = 1;
      }
    },
    //校验折扣90%-100%
    discountCheck(obj) {
      if (Number(obj.num) || Number(obj.num) === 0) {
        //数字
        obj.num = parseInt(obj.num);
        if (Number(obj.num) > 100) {
          obj.num = 100;
          Toast("请输入90~100之间的折扣");
        }
        if (Number(obj.num) < 90) {
          obj.num = 90;
          Toast("请输入90~100之间的折扣");
        }
      } else {
        obj.num = 100;
        Toast("请输入90~100之间的折扣");
      }
    },

    // 计算总价
    getTotalAmount: function() {
      let amount = 0;
      let arr = this.serviceItems;
      var totalMoney_temp = 0;

      var fsPrice = null;
      var percent = null;
      var discount = null; //折扣比例 除以100
      for (let i = 0, j = arr.length; i < j; i++) {
        if (arr[i].isselected) {
          if (arr[i].unit == "5") {
            //百分比不参与相乘相加计算
            percent = arr[i].price;
            continue;
          }
          if (arr[i].itemtype == 2) {
            //折扣不参与相乘相加计算
            discount = arr[i].num / 100;
            continue;
          }
          if (arr[i].itemtype == "1") {
            // 计算所有防水价格
            fsPrice = arr[i].price * (arr[i].num || 0);
          }
          var temp = arr[i].price * (arr[i].num || 0);
          temp = Math.round(temp * 100) / 100;
          totalMoney_temp += temp;
        }
      }
      if (fsPrice) {
        console.log("防水总价：" + fsPrice);
      }
      if (percent) {
        console.log("附加百分比：" + percent);
      }
      if (fsPrice && percent) {
        var pay = (Number(fsPrice) * Number(percent)) / 100;
        totalMoney_temp += pay;
        console.log("难度增加费" + pay);
        console.log("---------");
      }
      if (discount) {
        console.log("折扣前：" + totalMoney_temp);
        totalMoney_temp = totalMoney_temp * discount;
        console.log("折扣比例：" + discount);
        console.log("折扣后：" + totalMoney_temp);
      }
      // amount = amount.toFixed(2);
      // amount = parseFloat(amount);.round(amount * 100) / 100;
      totalMoney_temp = Math.round(totalMoney_temp * 100) / 100;
      this.totalamount = totalMoney_temp < 0 ? 0 : totalMoney_temp;
    },
    // 新增  -- 增项
    addItemClick: function() {
      let arr = this.serviceItems;
      let obj = {};
      obj.itemid = "";
      obj.itemname = "自定义项增项";
      obj.price = 1;
      obj.servicecost = 1;
      obj.materialcost = 0;
      obj.num = "";
      obj.memo = "请输入自定义项备注";
      obj.type = "custom";
      obj.itemtype = 1;
      obj.isselected = true;
      arr.push(obj);
    },
    // 新增  -- 减项
    delItemClick: function() {
      let arr = this.serviceItems;
      let obj = {};
      obj.itemid = "";
      obj.itemname = "自定义项减项";
      obj.price = -1;
      obj.servicecost = -1;
      obj.materialcost = 0;
      obj.num = "";
      obj.memo = "请输入自定义项备注";
      obj.type = "custom";
      obj.itemtype = -1;
      obj.isselected = true;
      arr.push(obj);
    },
    // 下单
    saveOrderClick: function() {
      let $that = this;
      let obj = this.orderData();
      this.oderTypeData(obj.id_billorderproductbody);
      console.log(obj);
      if (!obj) return;
      // return;
      this.$dialog
        .confirm({
          title: "提醒",
          message: "请确认特殊单位对应数量是否正确！",
          confirmButtonText: "直接下单",
          cancelButtonText: "返回查看",
          cancelButtonColor: "#1989fa"
        })
        .then(() => {
          // on confirm
          Indicator.open("正在下单...");
          $that.$ajax.post(
            $that.$$api.mobile.takeOrder,
            {
              order: JSON.stringify(obj)
            },
            response => {
              if (
                response.status == 200 &&
                response.data.success == "success"
              ) {
                var msg = response.data.detailMsg.data;
                Indicator.close();
                $that.$toast({
                  message: "下单成功",
                  duration: 1000
                });
                $that.$router.push("/imgupdate");
              } else {
                Indicator.close();
                $that.$messagebox(response.data.message);
                console.log(response, 0);
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    oderTypeData(arr) {
      arr.forEach(item => {
        if (item.itemid != "") {
          item.itemtype = 0;
        } else if (item.itemname == "自定义项增项") {
          item.itemtype = 1;
        } else if (item.itemname == "自定义项减项") {
          item.itemtype = -1;
        } else if (item.itemname == "折扣") {
          item.itemtype = 2;
        }
      });
    },
    // 数据 整合
    orderData: function() {
      let $that = this;
      let serviceItems = this.serviceItems;
      let items = [];
      for (let serviceItem of serviceItems) {
        if (serviceItem.isselected) {
          let item = {};
          item.itemid = serviceItem.itemid;
          item.itemname = serviceItem.itemname;
          item.type = serviceItem.type;
          item.itemtype = serviceItem.itemtype;
          item.price = serviceItem.price;
          item.num = serviceItem.num;
          item.unit = serviceItem.unit;
          item.memo = serviceItem.memo;
          item.servicecost = serviceItem.servicecost;
          item.materialcost = serviceItem.materialcost;
          item.isselected = serviceItem.isselected;
          items.push(item);
        }
      }
      // console.log(serviceItems);
      let obj = {};
      obj.num = this.area;
      obj.serviceid = this.serviceid;
      obj.id_billorderproductbody = items;
      obj.totalmny = this.totalamount;
      obj.partone = this.partone.value;
      obj.parttwo = this.parttwo.value;
      obj.reason = this.reason;
      obj.clientname = this.clientname;
      obj.operator = this.operator;
      obj.telphone = this.telphone;

      //验证电话号码-
      let phoneReg = /^1[3456789]\d{9}$/;

      if (!this.area) {
        Toast({
          message: "请填写维修面积",
          duration: 1500
        });
        return;
      } else if (!this.clientname) {
        console.log(this.clientname);
        Toast({
          message: "请填写委托人",
          duration: 1500
        });
        return;
      } else if (!this.telphone) {
        Toast({
          message: "请填写联系电话",
          duration: 1500
        });
        return;
      } else if (!phoneReg.test(this.telphone)) {
        Toast({
          message: "请填写正确的联系电话",
          duration: 1500
        });
        return;
      }
      return obj;
    },
    // 生成报表
    takeReport: function() {
      var $that = this;
      var obj = this.orderData();
      //    part:"",
      // columns1:[],
      // columns2:[],
      // partone:{
      //   name:"",
      //   value:""
      // },
      // parttwo:{
      //   name:"",
      //   value:""
      // },
      this.oderTypeData(obj.id_billorderproductbody);
      if (!obj) return;
      // return;
      this.$dialog
        .confirm({
          title: "提醒",
          message: "请确认特殊单位对应数量是否正确！",
          confirmButtonText: "生成报价",
          cancelButtonText: "返回查看",
          cancelButtonColor: "#1989fa"
        })
        .then(() => {
          Indicator.open("正在生成...");
          $that.$ajax.post(
            $that.$$api.mobile.takeReport,
            {
              order: JSON.stringify(obj)
            },
            response => {
              if (
                response.status == 200 &&
                response.data.success == "success"
              ) {
                var msg = response.data.detailMsg.data;
                Indicator.close();
                $that.$toast({
                  message: "报价已生成",
                  duration: 1000
                });
                $that.$router.push("/imgupdate");
              } else {
                Indicator.close();
                $that.$messagebox(response.data.message);
                console.log(response, 0);
              }
            }
          );
        })
        .catch(() => {});
    },

    //修改维修面积并同步
    areaChange: function(e) {
      var $that = this;
      if (e.target.value) {
        var area = e.target.value.match(/^\d*(\.?\d*)/g)[0] || 1;
        area = area < 1 ? 1 : area;
        this.area = area || 1;
      }
      if (this.serviceItems && this.serviceItems.length > 0) {
        for (var item of this.serviceItems) {
          if (item.unit == "1") {
            item.num = area || 1;
          }
        }
      }
    }
  },
  watch: {
    // 'isCheckAll': function(curVal,oldVal){
    //       console.log('%c'+curVal,'color:red');
    // },
    serviceItems: {
      handler: function(curVal, oldVal) {
        this.getTotalAmount();
      },
      deep: true
    },
    // 维修部位改变
    type() {
      this.activeAgelimit = null; // 年限强制改变 才会重复请求细项
      this.serviceItems = [];
    }
  }
};
</script>

<style scoped>
.popup {
  display: flex;
  flex-direction: column;
}
.popup-top {
  height: 40px;
  line-height: 40px;
  text-align: center;
}
.popup-top > button {
  width: 50px;
  height: 30px;
  margin: 5px;
  line-height: 30px;
  border-radius: 30px;
}
.popup-content {
  flex: 1;
  display: flex;
  flex-direction: row;
}
.popup-left {
  width: 80px;
  overflow: auto;
  background-color: #fafafa;
}
.popup-right {
  flex: 1;
  overflow-y: auto;
  padding: 0 10px;
  line-height: 44px;
}
.popup-left > div {
  padding: 12px 8px 12px 12px;
  border-left: 3px solid transparent;
  position: relative;
}
.popup-right > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.left-active {
  border-color: #ee0a24 !important;
  background-color: #fff;
}
.container {
  font-size: 4vw;
}

::-webkit-input-placeholder {
  font-size: 3.5vw;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item-group {
  width: 100%;
  box-sizing: border-box;
  word-wrap: break-word;
  padding: 3.226vw;
  display: flex;
  justify-content: space-between;
}

.item-title {
  width: 35%;
  text-align: left;
  height: 100%;
}

.item-content {
  width: 65%;
  text-align: right;
  font-size: 3.5vw;
  /*background: blue;*/
}

.item-content input {
  font-size: 3.5vw;
}

.item-value {
  width: 90%;
  display: inline-block;
  height: 100%;
  padding: 0;
  margin: 0;
}

.item-value input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  text-align: right;
  padding: 0;
  margin: 0;
  display: flex;
  align-content: center;
  /*background: red;*/
}

.product-title label {
  width: 100%;
  height: 100%;
  display: inline-block;
  display: flex;
  align-items: center;
}

.item-point i {
  font-size: 0.4rem;
  margin-left: 5px;
}

/* 细项 */
.sub-group {
  box-sizing: border-box;
  padding: 3.226vw;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 0 0.27rem -2px rgba(0, 0, 0, 0.5);
}

.sub-opera > input {
  width: 10vw;
  border: none;
  outline: none;
  padding: 5px;
}

.sub-opera > span {
  display: inline-block;
  width: 7vw;
  text-align: center;
}

.sub-input {
  margin-right: 0.27rem;
  position: relative;
}

.all-input i,
.sub-input i {
  font-size: 0.7rem;
}

.all-input input,
.sub-input input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 20;
  opacity: 0;
}

.sub-memo {
  padding-left: 10vw;
  font-size: 3vw;
}

.sub-memo input {
  outline: none;
  border: none;
  width: 90%;
  height: 100%;
  background: transparent;
  font-size: 3vw;
}

/* item-foot    */
.item-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 11.53vw;
  background: #fff;
  overflow: hidden;
}

.item-total {
  height: 100%;
  line-height: 11.53vw;
  padding: 0 2.419vw;
}

.item-save {
  width: 23vw;
  color: #fff;
  height: 100%;
  line-height: 11.53vw;
  font-size: 3.871vw;
}

/* modal_productList */
.modal_productList {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.modal_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
}

.modal_content {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 15;
  width: 100%;
  max-height: 42vh;
  /*background: #fff;*/
  background: #e0e0e0;
  overflow: hidden;
  /*-webkit-transform: translate3d(-50%, 0, 0);*/
  /*transform: translate3d(-50%, 0, 0);*/
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: -webkit-transform 0.3s ease-out;
  transition: -webkit-transform 0.3s ease-out;
  transition: transform 0.3s ease-out;
  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
}

.modal-list {
  /*position: absolute;*/
  /*bottom:7vh;*/
  /*left: 0;*/
  width: 100%;
  max-height: 34vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-opera > span {
  display: inline-block;
  width: 50%;
  height: 100%;
  box-sizing: border-box;
}

.modal-opera,
.modal-item {
  width: 100%;
  height: 7.8vh;
  border-bottom: 1px solid #e0e0e0;
  display: block;
  line-height: 7.8vh;
  color: #333;
  background-color: #fff;
  font-size: 18px;
}

.modal-opera:active,
.modal-item.on {
  background-color: #f0f0f0;
}

.modal-opera {
  /*position: absolute;*/
  /*bottom:0;*/
  /*left: 0;*/
  width: 100%;
  /*height:7vh;*/
  box-sizing: border-box;
  border-top: 0;
  margin-top: 10px;
}

.btn_add {
  padding: 2vw;
  border-radius: 5px;
}

/*提示信息*/
.tips .content {
  position: fixed;
  top: 9vh;
  left: 0;
  height: 6vh;
  width: 100%;
  box-sizing: border-box;
  background: rgb(245, 185, 108);
  color: #fff;
  padding: 2vw;
  font-size: 2vw;
  z-index: 8;
}

.c_nowrap_ms {
  overflow: hidden;
  white-space: nowrap;
}

.productTitle {
  width: 100%;
}
/*维修部位底部固定*/
.van-picker {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 2;
}
/*细项选择器 底部固定定位*/
.fineItem_box {
  position: fixed;
  bottom: 0;
  height: 80vw !important;
  z-index: 30;
  width: 100vw;
}
.fineItem_top {
  height: 10vw;
  background: #fff;
  line-height: 10vw;
  border-bottom: 1px solid #ebedf0;
}
.van-tree-select {
  height: 70vw !important;
}
/*细项 太长滚动展示*/
.van-tree-select__content > div {
  overflow: auto;
  white-space: pre-wrap;
  text-overflow: inherit;
  padding-left: 20px;
}
/*细项选择器 左侧宽度*/
.van-sidebar.van-tree-select__nav {
  -webkit-box-flex: unset;
  -webkit-flex: unset;
  flex: none;
  width: 70px;
}
/*细项左侧导航 角标*/ /*
  .van-info.van-sidebar-item__info{
    right:-5px;
  }*/
/*选择对勾 定位*/
.van-tree-select__selected {
  left: 1px;
}
.fineItem_top {
  display: flex;
  justify-content: space-between;
}
/*确认 取消细项按钮*/
.fineItem_cancel {
  color: #1989fa;
  width: 20vw;
  text-align: center;
}
.fineItem_confirm {
  color: #1989fa;
  width: 15vw;
  text-align: center;
}
.fineItem_filter {
  width: 65vw;
  text-align: center;
}
.fineItem_top .van-button {
  height: 7vw;
  line-height: 7vw;
  font-size: 10px !important;
  border-radius: 7vw;
  margin: 0 5px;
}
.warranty_sel {
  /*选中年限按钮*/
  background: #07c160;
  color: #fff !important;
}
/*细项展示*/
.card {
  background: #fff;
  border-radius: 2vw;
  margin: 2vw;
  padding: 3vw 5vw;
}
.card_title {
  line-height: 4vw;
}
.card_item {
  margin-top: 4vw;
  font-size: 3.5vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card_item_del {
  padding-right: 5vw;
}
.card_item_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#sticky button {
  background: #fff;
  color: #000;
  border: none;
  width: 49%;
}
.van-tree-select__item {
  padding: 10px 3px 10px 16px;
  line-height: 20px;
}
.units {
  height: 21px;
}
.van-dropdown-menu__title {
  font-size: 3.5vw;
  font-weight: 500;
}
.units::after {
  border: none;
}
.units span.van-dropdown-menu__title {
  font-size: 3.5vw;
}
</style>



// WEBPACK FOOTER //
// src/components/takeorder.vue